// extracted by mini-css-extract-plugin
module.exports = {"container":"AdPlacement_container__gsPki","hasAlerts":"AdPlacement_hasAlerts__ZG4gy"};